import { render, staticRenderFns } from "./App.vue?vue&type=template&id=accab2e0"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=accab2e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports